import { z } from "zod";
import { MoneySchema } from "../common/money.js";
import { IsoDateTimeSchema } from "../common/primitives.js";
import { EntitlementValueSchema } from "../me/index.js";
const PlanCodeSchema = z.enum(["solo", "starter", "pro", "business", "enterprise"]);
const SubscriptionStatusSchema = z.enum([
  "trialing",
  "active",
  "past_due",
  "read_only",
  "suspended",
  "paused",
  "cancelled"
]);
const EntitlementMapSchema = z.record(z.string().max(100), EntitlementValueSchema);
const PlanSchema = z.strictObject({
  code: PlanCodeSchema,
  monthlyPrice: MoneySchema.nullable(),
  annualPrice: MoneySchema.nullable(),
  extraSeatMonthlyPrice: MoneySchema.nullable(),
  entitlements: EntitlementMapSchema
});
const PlanListSchema = z.strictObject({ items: z.array(PlanSchema).max(20) });
const OrganizationEntitlementsSchema = z.strictObject({
  plan: PlanCodeSchema,
  subscriptionStatus: SubscriptionStatusSchema,
  trialEndsAt: IsoDateTimeSchema.nullable(),
  seats: z.strictObject({
    /** Seats of the plan plus extra seats bought; null = unlimited (Enterprise contract). */
    capacity: z.int().min(0).nullable(),
    /** Active members that take a seat (invited, not yet accepted members do not). */
    used: z.int().min(0)
  }),
  entitlements: EntitlementMapSchema
});
export {
  EntitlementMapSchema,
  OrganizationEntitlementsSchema,
  PlanCodeSchema,
  PlanListSchema,
  PlanSchema,
  SubscriptionStatusSchema
};
//# sourceMappingURL=index.js.map